// Raycast.js
var Raycast = pc.createScript('raycast');

Raycast.attributes.add('menuEntity', {type: 'entity', title: 'menuEntity'});

Raycast.prototype.timerDuration = 1;

// initialize code called once per entity
Raycast.prototype.initialize = function() {
    
    this.source = this.app.root.findByName('source');
    this.menuWrapper = this.app.root.findByName('menu_wrapper');
    this.menuWrapperFlag = true;
    this.menuWrapper.enabled = this.menuWrapperFlag;
    
    this.hitMarker = this.app.root.findByName('boxmarker');
    this.hitFlag = false;
    
    this.currentLoadedSceneId = null;
    
    //vars for pressTimer
    this.buttonIsPressed = false;
    this.pressTimerLimitReached = false;
    this.pressTimerIndicator = this.app.root.findByName('press_timer_indicator');
        
    // Add a mousedown event handler
    this.app.mouse.on(pc.EVENT_MOUSEDOWN, this.mouseDown, this);   
    
    // Add touch event only if touch is available
    if (pc.platform.mobile) {
        this.app.touch.on(pc.EVENT_TOUCHSTART, this.buttonPress, this);
        this.app.touch.on(pc.EVENT_TOUCHEND, this.buttonRelease, this);
    } else {
        this.app.mouse.on(pc.EVENT_MOUSEDOWN, this.buttonPress, this);
        this.app.mouse.on(pc.EVENT_MOUSEUP, this.buttonRelease, this);
    }
    
    //console.log(MenuLoader.prototype.posArray);
    
    this.timer = 0;
    this.isTimerActive = false;
    
    
    this.app.on('vrControllerPressed', this.onVrButton, this);
    
    //this.app.on('moveMarker:Right', this.moveMarkerRight, this);
    //this.app.on('moveMarker:Left', this.moveMarkerLeft, this);
    
    //this.app.on('do:Raycast', this.doRaycast, this);
    //this.app.on('do:Raycast', this.doRaycastMobile, this);
    
};

Raycast.prototype.onVrButton = function (e) {
    //this.app.fire('setDebugText', {text:'vrControllerPressed: '+e});
    
    if(e === 'up') {
        this.buttonRelease();
    } else if(e === 'down') {
        this.buttonPress();
    }
};

Raycast.prototype.beginTimer = function() {
    this.isTimerActive = false;
};


Raycast.prototype._onButtonClick = function(e) {
    //this.doRaycast(e);
};

Raycast.prototype.buttonPress = function (e) {
    this.buttonIsPressed = true;
    
    /*
    if (e.touches.length == 3) {
        this.doRaycast(e.touches[0]);
    }
    e.event.preventDefault();
    */
};

Raycast.prototype.buttonRelease = function (e) {
    this.buttonIsPressed = false;
    this.timer = 0;
    this.pressTimerLimitReached = false;
    this.pressTimerIndicator.setLocalScale(0,1,0);
    /*
    if (e.touches.length == 3) {
        this.doRaycast(e.touches[0]);
    }
    e.event.preventDefault();
    */
};


// update code called every frame
Raycast.prototype.update = function(dt , e) {
    
    ////////update the hitmarker position 
    var screenPosition = {x:window.innerWidth/2, y:window.innerHeight/2};
    
    // The vec3 to raycast from
    var fromCam = this.entity.getPosition();
    // The vec3 to raycast to 
    var toCam = this.entity.camera.screenToWorld(screenPosition.x, screenPosition.y, this.entity.camera.farClip);
    
    // Raycast between the two points
    var result = this.app.systems.rigidbody.raycastFirst(fromCam, toCam);
    
    if (result) {
        
        /*
        var rotation = result.entity.getEulerAngles();
        rotation.y = rotation.y + 90;
        this.hitMarker.setEulerAngles(rotation);
        this.hitMarker.setPosition(result.entity.getPosition());
        */

        
        if(this.buttonIsPressed && !this.pressTimerLimitReached) {
            
            this.timer += dt;
            
            //trigger action after pressTimer finished
            if (this.timer >= this.timerDuration) {
                this.timer = this.timerDuration;
                this.pressTimerLimitReached = true;
                //console.log('limit reached');
                
                if(result.entity.name === 'toggle_menu') {
                    this.toggleMenu(result);    
                }
                
                if(result.entity.script) {
                    //raycast result has targetLink script
                    if(result.entity.script.targetLink) {

                        var targetUrl = result.entity.script.targetLink.url;
                        var sceneId = result.entity.script.targetLink.sceneId;

                        console.log('open scene id', sceneId);

                        if(targetUrl) {
                            location.href = result.entity.script.targetLink.url;
                        } else if(sceneId) {
                            this.app.fire('sceneLoader:loadScene', sceneId);
                        }
                    }
                } else {
                    console.log('no script on raycast result');
                }
            }
            
            var adjustedScale = this.timer / 10;
            this.pressTimerIndicator.setLocalScale(adjustedScale,1,adjustedScale);
        }
        
    } else {    
        this.hitFlag = false;
        this.timer = 0;
        this.pressTimerLimitReached = false;
        this.pressTimerIndicator.setLocalScale(0,1,0);
    }
};

/*
Raycast.prototype.moveMarkerRight = function() {
    for ( i = 0; i < MenuLoader.prototype.posArray.length; i++) {  
        var pos = i + 1;
       
        if(pos > MenuLoader.prototype.posArray.length - 1) {
            pos = 0;
            MenuLoader.prototype.posArray[i].tween(MenuLoader.prototype.posArray[i].getLocalEulerAngles()).rotate(MenuLoader.prototype.posArray[pos].getLocalEulerAngles(), this.timerDuration, pc.SineOut).start();
        } else {
            MenuLoader.prototype.posArray[i].tween(MenuLoader.prototype.posArray[i].getLocalEulerAngles()).rotate(MenuLoader.prototype.posArray[pos].getLocalEulerAngles(), this.timerDuration, pc.SineOut).start();    
        }   
    }
};

Raycast.prototype.moveMarkerLeft = function() {
    for (var i = 0; i < MenuLoader.prototype.posArray.length; i++) {  
        var pos = i - 1;
       
        if(pos < 0) {
            pos = 0;
            MenuLoader.prototype.posArray[i].tween(MenuLoader.prototype.posArray[i].getLocalEulerAngles()).rotate(MenuLoader.prototype.posArray[MenuLoader.prototype.posArray.length-1].getLocalEulerAngles(), this.timerDuration, pc.SineOut).start();
        } else {
            MenuLoader.prototype.posArray[i].tween(MenuLoader.prototype.posArray[i].getLocalEulerAngles()).rotate(MenuLoader.prototype.posArray[pos].getLocalEulerAngles(), this.timerDuration, pc.SineOut).start();    
        }
    }
};
*/

/*
Raycast.prototype.doRaycast = function(e, identifier) {
    var screenPosition = {x:window.innerWidth/2, y:window.innerHeight/2};
    
    // The vec3 to raycast from
    var from = this.entity.getPosition();
   
    // The vec3 to raycast to 
    var to = this.entity.camera.screenToWorld(screenPosition.x, screenPosition.y, this.entity.camera.farClip);
    
    // Raycast between the two points
    var result = this.app.systems.rigidbody.raycastFirst(from, to);
   
    if (result) {
        
        
        if(result.entity.name === 'toggle_menu') {
            this.toggleMenu(result);    
        }
        
        if (result.entity.script) {
            
            //result.entity.setLocalScale(0.5, 0.5, 0.5);
            
            setTimeout(function() {
                //result.entity.setLocalScale(1,1,1);
            }, 300);
            
            
            //raycast result has targetLink script
            if(result.entity.script.targetLink) {
                
                var targetUrl = result.entity.script.targetLink.url;
                var sceneId = result.entity.script.targetLink.sceneId;
                
                console.log('open href', targetUrl, sceneId);
                
                if(targetUrl) {
                    location.href = result.entity.script.targetLink.url;
                } else if(sceneId) {
                    this.app.fire('sceneLoader:loadScene', sceneId);
                }
            }
        }
    } 
};
*/

/*
for (var i = 0; i < MenuLoader.prototype.posArray.length; i++) {  
    if (MenuLoader.prototype.posArray[i].getLocalEulerAngles().z > 48 && MenuLoader.prototype.posArray[i].getLocalEulerAngles().z < 51) {
        var select = MenuLoader.prototype.posArray[i].findByName('ButtonSphere');
        location.href = select.script.targetLink.url;
    }
}
*/  

Raycast.prototype.toggleMenu = function(result) {
    
    this.menuWrapperFlag = !this.menuWrapperFlag;
    this.menuWrapper.enabled = this.menuWrapperFlag;

    console.log('result 1', this.menuWrapperFlag);
};

/*
Raycast.prototype.doRaycastMobile = function (e) { 

    var screenPosition = {x:window.innerWidth/2, y:window.innerHeight/2};
    
    // The vec3 to raycast from
    var from = this.entity.getPosition();
    // The vec3 to raycast to 
    var to = this.entity.camera.screenToWorld(screenPosition.x, screenPosition.y, this.entity.camera.farClip);

    // Raycast between the two points
    var result = this.app.systems.rigidbody.raycastFirst(from, to);
   
    if (result) {
        
        console.log('result 2', result);
        
        if(result.entity.script) {
            
            var localScale = result.entity.getLocalScale().clone();
            
            result.entity.setLocalScale(0.5, 0.5, 0.5);
            
            setTimeout(function() {
                result.entity.setLocalScale(1, 1, 1);
            }, 300);
            
            //location.href = result.entity.script.targetLink.url;
        }
     }
};
*/


Raycast.prototype.getDistance = function (pos1, pos2) {
    var x = pos1.x - pos2.x;
    var y = pos1.y - pos2.y;
    var z = pos1.z - pos2.z;

    var temp = new pc.Vec3(x, y, z);
    return temp.length ();
};




